import {
  PermissionDisplayOrder,
  PermissionGroupMap,
  PermissionNameMap,
} from 'config/PermissionAndGroup';
import { tierTypeConfig } from 'config/TierTypeConfig';
import { BaseHelper } from 'services/BaseGraphQLAPIHelper';

import { capitalizeFirstLetter } from 'utils/StringUtil';

export const getAllPermissions = (afterCursor, isMerchant = false) => {
  const query = `query AdminPermissions($isMerchant: Boolean) {
    permissions(
      first: 200
      after: "${afterCursor}"
      isMerchant: $isMerchant
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          name
          codename
          adminGroupName
        }
      }
    }
  }`;

  const variables = {
    "isMerchant": isMerchant,
  };

  return BaseHelper.callGraphQLAPI({ query, variables });
};

const getPermissionName = (codename, originName) => {
  if (PermissionNameMap?.hasOwnProperty(codename)) {
    return PermissionNameMap[codename];
  }
  return originName;
};

const getPermissionGroupName = (codename, adminGroupName) => {
  if (PermissionGroupMap?.hasOwnProperty(codename)) {
    return PermissionGroupMap[codename];
  }
  return `${adminGroupName}s`;
};

function compareFn(a, b) {
  return (
    PermissionDisplayOrder.indexOf(a.codename) -
    PermissionDisplayOrder.indexOf(b.codename)
  );
}

export const parsePermissionList = (permissions) => {
  const data =
    permissions?.edges.map((item) => {
      const { node } = item;
      const { adminGroupName, codename, name } = node;
      const permissionName = getPermissionName(codename, name);
      const permissionGroupName = getPermissionGroupName(
        codename,
        adminGroupName,
      );
      return {
        id: node.id,
        pk: node.pk,
        realPk: node.pk,
        name: permissionName,
        codename,
        groupKey: {
          pk: permissionGroupName,
          name: capitalizeFirstLetter(permissionGroupName),
        },
      };
    }) || [];

  const filterData = data.filter(permission => {
    if (
      !tierTypeConfig.segments
      && [
        "view_segment",
        "change_segment",
      ].includes(permission.codename)
    ) {
      return false;
    }
    if (
      !tierTypeConfig.messages
      && [
        "view_message",
        "change_message",
        "test_message",
        "step_draft_message_create",
        "step_draft_message_edit",
        "step_draft_message_pending",
        "step_pending_message_edit",
        "step_pending_message_publish",
        "step_pending_message_withdraw_to_draft",
        "step_publish_create_temp_message",
        "step_publish_message_withdraw_to_draft",
        "step_publish_message_withdraw_to_pending",
        "change_systemmessage",
      ].includes(permission.codename)
    ) {
      return false;
    }
    return true;
  })

  return filterData.sort(compareFn);
};
